import { NavLink } from 'react-router-dom';
import clsx from 'clsx';
import { getDpPortalTabHref } from '../../dpPortal.definitions';
import { useDpPortalTabs } from '../../hooks/useDpPortalTabs';

const SKELETON_KEYS = [0, 1, 2];

const LIST_CLASS = 'flex w-max gap-1 rounded-full border border-primary-100 bg-white p-1 shadow-sm';

export function DpPortalTabNav() {
    const { tabs, isLoading } = useDpPortalTabs();

    if (isLoading) {
        return (
            <ul className={LIST_CLASS} aria-busy="true" aria-label="Carregando seções">
                {SKELETON_KEYS.map(key => (
                    <li key={key} className="h-9 w-28 animate-pulse rounded-full bg-raro-gray-100" />
                ))}
            </ul>
        );
    }

    return (
        <nav
            aria-label="Seções do Portal do DP"
            className="min-w-0 max-w-full overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
        >
            <ul className={LIST_CLASS}>
                {tabs.map(tab => (
                    <li key={tab.id}>
                        <NavLink
                            to={getDpPortalTabHref(tab)}
                            className={({ isActive }) =>
                                clsx(
                                    'inline-flex items-center whitespace-nowrap rounded-full px-4 py-2 text-sm font-montserrat transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500',
                                    isActive
                                        ? 'bg-primary-600 font-semibold text-white shadow-sm'
                                        : 'font-medium text-raro-gray-600 hover:bg-primary-50 hover:text-primary-700'
                                )
                            }
                        >
                            {tab.label}
                        </NavLink>
                    </li>
                ))}
            </ul>
        </nav>
    );
}
